<div class="question-wrapper" id="QuestionWraper">
  <div class="tag dark-blue optional-question hidden" id="optionalQuestion">Pregunta Opcional</div>
  <h1 class="text-center without-help text-02-m-light text-01-d-light">
    {{ question.QuestionText }}
  </h1>
  <div class="cj-tooltip hidden" id="tooltip">
    <span class="icon icon-info-line"></span>
    <p class="text-09-m-regular text-11-d-regular"></p>
  </div>
  <div class="form-control input" id="divTelephone">
    <label for="input">
      Teléfono
      <span id="prefilledPhone" style="display: none"> (Utilizaste éste en la anterior comparativa. Si quieres, puedes cambiarlo) </span>
    </label>
    <input
      type="tel"
      [ngModel]="applyTeleMask()"
      (ngModelChange)="onTeleModelChange($event)"
      (focus)="onTeleFocusField()"
      maxlength="9"
      name="txtTelephone"
      id="txtTelephone"
      placeholder="Teléfono"
      (keypress)="onKeyPress($event)"
      (paste)="(false)"
      pattern="[0-9]*"
      autocomplete="off"
      class="text-input text-09-d-demibold"
      [class.error]="!isValid" />
  </div>
  <div class="col-md-12 col-sm-12 col-xs-12 error" [class.hidden]="isValid">
    <p id="errorContainer">Por favor, introduce un número de teléfono válido</p>
  </div>
</div>
<button id="btnClose" class="btn solid-main" (click)="saveSectionAnswer()" style="max-width: 185px">Guardar</button>
